import script from "./CameraIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraIcon.vue?vue&type=script&setup=true&lang=js"

import "./CameraIcon.vue?vue&type=style&index=0&id=1eeca95f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eeca95f"]])

export default __exports__